import { Box } from '@mui/material'
import React from 'react'
import { SwitchButtonOption } from '../../../interfaces/Generic/State'

interface SwitchButtonProps {
  options: SwitchButtonOption[]
  isSelected: string
  handleClick: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    field: string
  ) => void
}

export const SwitchButton = ({
  options,
  isSelected,
  handleClick
}: SwitchButtonProps) => {
  return (
    <Box
      component='form'
      display='flex'
      flexDirection='row'
      flexWrap='nowrap'
      alignItems='center'
      p={1}
      m={1}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid silver',
          borderRadius: '18px',
          boxShadow: '0px 2px rgba(0,0,0,0.3)',
          width: '300px',
          height: '30px',
          backgroundColor: '#fafafa'
        }}
      >
        {options.map((option, index) => (
          <button
            key={index}
            style={{
              background: option.value === isSelected ? '#004bb1' : 'none',
              color: option.value === isSelected ? 'white' : '#6E6C6C',
              width: 300 / options.length,
              border: '0px',
              borderRadius: '18px',
              height: '30px',
              fontWeight: 'bold',
              fontSize: '14px',
              transition: 'background 1s ease'
            }}
            onClick={(e) => handleClick(e, option.value)}
          >
            {option.label}
          </button>
        ))}
      </Box>
    </Box>
  )
}
